import React, { useCallback, useEffect, useState } from "react";
import Modal from "react-modal";
import { OnboardingCarousel } from "../../components/onboardingModalCarousel";
import { ScrollLock } from "../../modules/helpers/scrollLock";

export const OnboardingModal = () => {
  const [modalIsOpen, setModalIsOpen] = useState<boolean>(true);
  useEffect(() => ScrollLock.lock(), []);

  const handleHideModal = (showAgain: boolean) => {
    setModalIsOpen(false);
    ScrollLock.unlock();
    fetch(
      `${
        showAgain ? "/api/onboarding/1.0/shown" : "/api/onboarding/1.0/finished"
      }`,
      { method: "POST" }
    );
  };

  return (
    <Modal
      ariaHideApp={false}
      isOpen={modalIsOpen}
      onRequestClose={() => handleHideModal(true)}
      className="onboarding-modal-style"
      overlayClassName="onboarding-modal-overlay"
    >
      <div className="onboarding-modal">
        <div className="onboarding-modal__header">
          <button
            className="onboarding-modal__close"
            onClick={() => {
              handleHideModal(true);
            }}
          ></button>
        </div>
        <OnboardingCarousel handleHideModal={handleHideModal} />
      </div>
    </Modal>
  );
};
